import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import OurTeamHome from '@/components/prudent/ourTeam/OurTeamHome'
import AboutHome from '@/components/prudent/about/AboutHome'
import DiversityHome from '@/components/prudent/diversity/DiversityHome'
import CareerHome from '@/components/career/CareerHome'
import ContactHome from '@/components/contact/ContactHome'
import ResourceHome from '@/components/resource/ResourceHome'
import ServiceHome from '@/components/service/ServiceHome'
import Login from '@/components/auth/Login'

//for secured resources
import firebase from 'firebase'
import EmployeeHome from '@/components/employee/EmployeeHome'
import EditPersonalPolicy from '@/components/employee/insurance/EditPersonalPolicy'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            component: Home
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/team',
            name: 'OurTeamHome',
            component: OurTeamHome
        },
        {
            path: '/about',
            name: 'AboutHome',
            component: AboutHome
        },
        {
            path: '/diversity',
            name: 'DiversityHome',
            component: DiversityHome
        },
        {
            path: '/career',
            name: 'CareerHome',
            component: CareerHome
        },
        {
            path: '/contact',
            name: 'ContactHome',
            component: ContactHome
        },
        {
            path: '/resource',
            name: 'ResourceHome',
            component: ResourceHome
        },
        {
            path: '/service',
            name: 'ServiceHome',
            component: ServiceHome
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        // added secured paths
        {
            path: '/secured/employee',
            name: 'EmployeeHome',
            component: EmployeeHome
        },
        {
            path: '/secured/insurance/editPersonalPolicy',
            name: 'EditPersonalPolicy',
            component: EditPersonalPolicy
        }
    ]
})

router.beforeEach((to, from, next) => {
        let user = firebase.auth().currentUser

        console.log(to.path);

        //check to see if route requires auth
        if (to.path.startsWith('/secured')) {
            //check auth state of user
            if (user) {
                next()
            } else {
                next({name: 'Login'})
            }
        } else {
            next()
        }
    }
)

export default router


// WEBPACK FOOTER //
// ./src/router/mainIndex.js